module.exports = __webpack_public_path__ + "img/trust-money.b6651ba4.jpg";